import { render, staticRenderFns } from "./query-result.vue?vue&type=template&id=90414532"
import script from "./query-result.vue?vue&type=script&lang=ts"
export * from "./query-result.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports